var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/"}},[_c('img',{class:("cp-logo " + _vm.size),attrs:{"width":_vm.width,"height":_vm.height,"src":"/assets/img/cp-logo.svg","alt":"CareerPeakr"}})])}
var staticRenderFns = []

export { render, staticRenderFns }